import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["value", "width", "getPopupContainer", "onOpenChange", "popupClassName", "style", "onChange", "className"],
  _excluded2 = ["dropdownClassName", "width", "style", "className"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { TimePicker } from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import fiFI from 'rc-picker/lib/locale/fi_FI';
import React, { useEffect, useRef } from 'react';
import { HHmmFormat } from "../../utils/DixuConstants";
import { isMobileOrTabletBrowser, toRem } from "../../utils/Utils";

// Can't directly import locale from antd (some incompatibility with NextJS,
// investigate and fix if needed).
const localeFI = {
  lang: fiFI
};
const DixuTimePicker = _ref => {
  let {
      value,
      width,
      getPopupContainer,
      onOpenChange,
      popupClassName,
      style,
      onChange,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-time-picker', className);
  const containerRef = useRef(document.createElement('div'));
  const getContainer = (() => {
    if (getPopupContainer) {
      return getPopupContainer;
    }
    return () => containerRef.current;
  })();
  const handleOnOpenChange = currentOpen => {
    const element = containerRef.current;
    if (currentOpen) {
      element.classList.add('dixu-time-picker-container--open');
    } else {
      element.classList.remove('dixu-time-picker-container--open');
    }
    onOpenChange?.(currentOpen);
  };
  useEffect(() => {
    const element = containerRef.current;
    element.classList.add('dixu-time-picker-container');
    document.body.appendChild(element);
    return () => {
      if (document.body.contains(element)) {
        document.body.removeChild(element);
      }
    };
  }, []);
  const handleChange = (time, timeString) => {
    onChange?.(time, timeString);
  };
  return /*#__PURE__*/React.createElement(TimePicker, _objectSpread(_objectSpread({}, rest), {}, {
    needConfirm: false,
    className: classes,
    value: value && moment(value),
    format: HHmmFormat,
    locale: localeFI,
    placeholder: '',
    showNow: false,
    popupClassName: classNames('dixu-time-picker-dropdown', popupClassName),
    getPopupContainer: getContainer,
    onSelect: handleChange,
    onOpenChange: handleOnOpenChange,
    inputReadOnly: isMobileOrTabletBrowser(),
    minuteStep: 15,
    hideDisabledOptions: true,
    style: _objectSpread({
      width: toRem(width)
    }, style),
    onChange: handleChange
  }));
};
DixuTimePicker.defaultProps = {
  width: undefined
};
const DixuTimeRangePicker = _ref2 => {
  let {
      dropdownClassName,
      width,
      style,
      className
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  const classes = classNames('dixu-time-picker', 'dixu-time-picker--range', className);
  return /*#__PURE__*/React.createElement(TimePicker.RangePicker, _objectSpread({
    needConfirm: false,
    className: classes,
    dropdownClassName: classNames('dixu-time-picker-dropdown', 'dixu-time-picker-dropdown--range', dropdownClassName),
    format: HHmmFormat,
    locale: localeFI,
    placeholder: ['', ''],
    inputReadOnly: isMobileOrTabletBrowser(),
    minuteStep: 15,
    style: _objectSpread({
      width: toRem(width)
    }, style)
  }, rest));
};
DixuTimeRangePicker.defaultProps = {
  width: undefined
};
DixuTimePicker.RangePicker = DixuTimeRangePicker;
export default DixuTimePicker;